import { useContext } from 'react'
import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { apiPost } from 'api'
import AuthContext from 'context/auth-context'
import { getMunicipalityAppAccess } from 'utils/municipality-access'

// Admins may switch anywhere; accounting users only among their assigned municipalities.
const switchMunicipality = async (token, municipalityId, isAdmin) => {
  const url = isAdmin ? 'admin/municipality_switch' : 'municipality_switch'
  const data = await apiPost({
    url,
    token,
    objectName: 'municipality_switch',
    params: { municipality_id: municipalityId },
  })
  return data
}

export function useSwitchMunicipality({ isAdmin = true, options } = {}) {
  const token = useContext(AuthContext)

  return useMutation(
    (municipalityId) => switchMunicipality(token, municipalityId, isAdmin),
    {
      ...options,
      onSuccess: (data) => {
        const { canAccessSod, canAccessAnalytics } = getMunicipalityAppAccess(data)

        let destination
        if (canAccessSod && !canAccessAnalytics) {
          localStorage.setItem('sodApp', 'true')
          destination = '/duties'
        } else if (canAccessAnalytics && !canAccessSod) {
          localStorage.removeItem('sodApp')
          destination = '/dashboards'
        } else if (canAccessSod && canAccessAnalytics) {
          // User has access to both — stay in current app context
          destination = localStorage.getItem('sodApp') === 'true' ? '/duties' : '/dashboards'
        } else {
          destination = '/'
        }

        toast.success('Municipality switched successfully')
        window.location.assign(destination)
      },
    }
  )
}
